import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import ServerPricing from '../../homepage/header-banner/ServerPricing';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
// import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
import CardBoxRow from '../../container/Box/Components/CardBox-Row'
// import { MuiGrid } from '@mui/material';
import CommonTable from '../../container/Table/Components/CommonTable';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';


// Titlecloudcompute
function Soho() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = '소호형 - Private Kubernetes - 프라이빗 클라우드';
    }, []);
    return (
        <div className='App'>
            <NavButton option={{
                // logo: logoKube,
                logo: "https://hanbiro.com/cloud/library/banner/hanbiro.svg",
                link: "https://hanbiro.com/",
                color: { backgroundColor: '#7061ff' },
                itemNavClass: "item-nav nav-pur",
                menuListProduct: "menu-list-product-item",
                menuListVora: "vora",
                menuListGroupware: "groupware",
                titleTab: "mb-3",
            }} />
            <BannerPrivateCloud />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <Sidebar />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("소호형(한비로구성도)")} */}
                        {/* {Contentcloudcard("","")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12} className='MuiGrid-card'>{CardBoxRow(
                                "<p class='typo-21-sm typo-medium typo-black'>Private Kubernetes 소호형 구성도</p>",

                                `
                                <p class='typo-14'>Private Kubernetes 소호형은 VM으로 Master / Worker Node 로 운영합니다.</p>
                                <p class='typo-14'>Proxmox VE VM 가상화 서버를 사용, 최소 2대부터 프라이빗 쿠버네티스 클러스터를 구성할 수 있습니다.</p>
                                <p class='typo-14'>&nbsp;</p>
                                <ul>
                                    <li><p class='typo-14'>Proxmox VE 2대를 활용한 소호형 클러스터</p></li>
                                    <li><p class='typo-14'>소규모 팀 및 스타트업에 최적화된 경량형 솔루션</p></li>
                                    <li><p class='typo-14'>소규모 어플리케이션 운영에 적합</p></li>
                                    <li><p class='typo-14'>초기비용절감과 빠른 배포</p></li>
                                    <li><p class='typo-14'>테스트및 개발환경</p></li>
                                </ul>
                                `)}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/back-office-1.png")}</MuiGrid>
                            <MuiGrid item xs={12} className='MuiGrid-card'>{Imagecloudcompute("https://hanbiro.com/assets/images/cloud/back-office-2.png")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>

                        <Cloudconsult2 />
                    </Col>
                </Row>
            </Container>



            {/* <Cloudconsult /> */}
            <Footer option={{
                textColor: "text-color external-link text-pur-color",
                textlinkColor: "text-color text-pur-color"
            }} />
        </div>
    );
};

const MuiGrid = styled.div`
    padding: 0px,
`

export default Soho;